import { defineStore } from 'pinia'
import repositoryFactory from '@/factories/repository-factory'
import WeatherWarning2Repository from '@/repositories/weather-warning2-repository'
import WeatherWarning2 from '@/models/WeatherWarning2'
import { Area } from '@/models/WeatherWarning'

const storeKey = 'weather-warning'

type Store = {
  weatherWarningData: WeatherWarning2[]
}

export const useWeatherWaringStore = defineStore(storeKey, {
  state: () =>
    ({
      weatherWarningData: [] as WeatherWarning2[],
    } as Store),

  actions: {
    async fetch(areaList: Area[]) {
      const repository = (await repositoryFactory.create()).get('weatherWarning2') as WeatherWarning2Repository

      this.weatherWarningData = await Promise.all(areaList.map(area => repository.get(area.code.toString())))
    },
  },
})
